import { tsValidateString } from '@nu-art/ts-common';
import { Validator_AIPromptType } from '../../_enum/ai-prompt-type/index.js';
const Validator_ModifiableProps = {
    label: tsValidateString(),
    content: tsValidateString(),
    type: Validator_AIPromptType,
};
const Validator_GeneratedProps = {};
export const DBDef_AIPrompt = {
    modifiablePropsValidator: Validator_ModifiableProps,
    generatedPropsValidator: Validator_GeneratedProps,
    versions: ['1.0.0'],
    dbKey: 'ai-prompt',
    entityName: 'ai-prompt',
    frontend: {
        group: 'app',
        name: 'ai-prompt',
    },
    backend: {
        name: 'ai-prompt',
    },
};
//# sourceMappingURL=db-def.js.map